/* *@description: 图片的手动缩放、拖拽 *@author: luomingkai *@date: 2021-12-22
22:14:41 *@version: V1.0.0 */
<template>
	<div class="canvas-box">
		<canvas
			v-show="!loadImgSrc"
			class="my-canvas"
			ref="canvasRef"
			@touchstart="touchstart"
			@touchmove="moveTouch"
			@touchend="endMouse"
			@mousedown="startMouse"
			@mousemove="moveMouse"
			@mouseup="endMouse"
		></canvas>
		<img v-show="loadImgSrc" :src="loadImgSrc" />
	</div>
</template>

<script>
	export default {
		props: {
			imgUrl: {
				type: String,
				default: '',
			},
		},
		watch: {
			imgUrl(newVal, oldVal) {
				console.log(oldVal)
				if (newVal) {
					this.$nextTick(() => {
						this.init()
					})
				}
			},
		},
		data() {
			return {
				ctx: null,
				img: null,
				startPos: { x: 0, y: 0 }, // 开始坐标
				touchs: [], // 存储多手指位置
				movePos: { x: 0, y: 0 }, // 存储移动坐标位置
				imgX: 0, // 图片初始化X轴位置
				imgY: 0, // 图片初始化Y轴位置
				isMove: false, // 是否移动
				imgScale: 0.5, // 图片缩放比例
				MINIMUM_SCALE: 0.05, // 最小缩放
				MAX_SCALE: 3,
				loadImgSrc: '',
			}
		},
		mounted() {
			this.$nextTick(() => {
				const { width, height } = this.$refs.canvasRef.getBoundingClientRect()
				this.$refs.canvasRef.width = width * 4
				this.$refs.canvasRef.height = height * 4
				this.ctx = this.$refs.canvasRef.getContext('2d')
				this.ctx.translate(0.5, 0.5)
				this.ctx.fillRect(0, 0, '50%', '50%')
				this.init()
			})
		},
		methods: {
			async init() {
				await this.loadImage(this.imgUrl)
				this.drawImage(true)
			},
			getPixelRatio(context) {
				// 获取设备的PixelRatio
				var backingStore =
					context.backingStorePixelRatio ||
					context.webkitBackingStorePixelRatio ||
					context.mozBackingStorePixelRatio ||
					context.msBackingStorePixelRatio ||
					context.oBackingStorePixelRatio ||
					context.backingStorePixelRatio ||
					1
				return (window.devicePixelRatio || 1) / backingStore
			},
			startMouse(e) {
				const { pageX, pageY } = e
				this.isMove = true
				this.startPos = this.windowToCanvas(pageX, pageY)
			},

			startTouch(e) {
				const { touches } = e
				this.isMove = true
				// 判断是否为多手指
				if (touches.length < 2) {
					const { clientX, clientY } = touches[0]
					this.startPos = this.windowToCanvas(clientX, clientY) // clientX：触摸点相对浏览器窗口的位置
				} else {
					this.touchs = touches
				}
			},
			moveMouse(e) {
				if (!this.isMove) return false
				const { pageX, pageY } = e
				this.movePos = this.windowToCanvas(pageX, pageY)
				const x = this.movePos.x - this.startPos.x,
					y = this.movePos.y - this.startPos.y
				this.imgX += x
				this.imgY += y
				this.startPos = { ...this.movePos } // 更新最新位置
				this.drawImage()
			},
			touchstart(e) {
				const { touches } = e
				this.isMove = true
				// 判断是否为多手指
				if (touches.length < 2) {
					const { clientX, clientY } = touches[0]
					this.startPos = this.windowToCanvas(clientX, clientY) // clientX：触摸点相对浏览器窗口的位置
				} else {
					this.touchs = touches
				}
			},
			// mouseWheel(e, wheelDelta) {
			// 	const { clientX, clientY, wheelDelta } = e
			// 	const pos = this.windowToCanvas(clientX, clientY)
			// 	// 计算图片的位置
			// 	const newPos = {
			// 		x: Number(((pos.x - this.imgX) / this.imgScale).toFixed(2)),
			// 		y: Number(((pos.y - this.imgY) / this.imgScale).toFixed(2)),
			// 	}
			// 	// 判断是放大还是缩小
			// 	if (wheelDelta > 0) {
			// 		// 放大
			// 		this.imgScale += 0.05
			// 		if (this.imgScale >= this.MAX_SCALE) {
			// 			this.imgScale = this.MAX_SCALE
			// 		}
			// 	} else {
			// 		// 缩小
			// 		this.imgScale -= 0.05
			// 		if (this.imgScale <= this.MINIMUM_SCALE) {
			// 			this.imgScale = this.MINIMUM_SCALE
			// 		}
			// 	}
			// 	// 计算图片的位置， 根据当前缩放比例，计算新的位置
			// 	this.imgX = (1 - this.imgScale) * newPos.x + (pos.x - newPos.x)
			// 	this.imgY = (1 - this.imgScale) * newPos.y + (pos.y - newPos.y)
			// 	this.drawImage() // 开始绘制图片
			// },
			moveTouch(e) {
				if (!this.isMove || !e.touches) return false
				const { clientX, clientY } = e.touches[0]
				// 如果是单指
				if (e.touches.length < 2) {
					this.movePos = this.windowToCanvas(clientX, clientY)
					const x = this.movePos.x - this.startPos.x,
						y = this.movePos.y - this.startPos.y
					this.imgX += x
					this.imgY += y
					this.startPos = { ...this.movePos } // 更新最新位置
				} else {
					const now = e.touches
					// 处理位置
					const pos = this.windowToCanvas(clientX, clientY)
					const newPos = {
						x: Number(((pos.x - this.imgX) / this.imgScale).toFixed(2)),
						y: Number(((pos.y - this.imgY) / this.imgScale).toFixed(2)),
					}
					const curPos = this.getDistance(now[0], now[1]) // 当前位置
					const startPos = this.getDistance(this.touchs[0], this.touchs[1]) // 前一个位置
					// 判断位置是放大还是缩小
					if (curPos > startPos) {
						// 放大
						this.imgScale += 0.008
						if (this.imgScale >= this.MAX_SCALE) {
							this.imgScale = this.MAX_SCALE
						}
					} else {
						this.imgScale -= 0.008
						if (this.imgScale <= this.MINIMUM_SCALE) {
							this.imgScale = this.MINIMUM_SCALE
						}
					}
					// 计算图片的位置， 更具当前缩放比例，计算新的位置
					this.imgX = (1 - this.imgScale) * newPos.x + (pos.x - newPos.x)
					this.imgY = (1 - this.imgScale) * newPos.y + (pos.y - newPos.y)
					this.touchs = now
				}
				this.drawImage()
			},
			endMouse() {
				this.isMove = false
			},
			windowToCanvas(startX, startY) {
				const { left, top, width, height } =
					this.$refs.canvasRef.getBoundingClientRect()
				return {
					x: startX - left - (width - this.$refs.canvasRef.width) / 2,
					y: startY - top - (height - this.$refs.canvasRef.height) / 2,
				}
			},
			getDistance(p1, p2) {
				const x = p2.pageX - p1.pageX
				const y = p2.pageY - p1.pageY
				return Math.sqrt(x * x + y * y)
			},

			drawImage(firstFlag) {
				// 清除上一帧绘制
				this.ctx.clearRect(
					0,
					0,
					this.$refs.canvasRef.width,
					this.$refs.canvasRef.height
				)
				// 剧中放置(首次)
				if (firstFlag) {
					// 计算缩小的比例
					let canvasWidth = this.$refs.canvasRef.width
					let canvasHeight = this.$refs.canvasRef.height
					let imgWidth = this.img.width
					let imgHeight = this.img.height
					let scale1 = canvasWidth / imgWidth
					let scale2 = canvasHeight / imgHeight
					if (scale1 < scale2) {
						if (scale2 > 0.01) {
							this.imgScale = scale2
						} else {
							this.imgScale = 1
						}
					} else {
						if (scale1 > 0.01) {
							this.imgScale = scale1
						} else {
							this.imgScale = 1
						}
					}
					this.imgX = (canvasWidth - this.img.width * this.imgScale) / 2
					this.imgY = (canvasHeight - this.img.height * this.imgScale) / 2
				}

				// 绘制图片
				let scr = this.getPixelRatio(this.ctx)
				this.ctx.drawImage(
					this.img,
					0,
					0,
					this.img.width,
					this.img.height,
					this.imgX,
					this.imgY,
					this.img.width * this.imgScale,
					this.img.height * this.imgScale
				)
			},
			loadImage(url) {
				return new Promise((reject, resolve) => {
					this.img = new Image()
					this.img.crossOrigin = 'Anonymous'
					let _self = this
					this.img.onload = function () {
						console.log(_self.img.width)
						console.log(_self.img.height)
						debugger
						reject('')
					}
					this.img.onerror = function (error) {
						console.error(error, 'error=====')
						resolve(error)
					}
					this.img.src = url
				})
			},

			generateImg(falg) {
				if (falg) {
					this.loadImgSrc = this.$refs.canvasRef.toDataURL('image/png', 1)
					console.log('this.loadImgSrc====', this.loadImgSrc)
				} else {
					this.loadImgSrc = ''
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
	.canvas-box {
		border-radius: '10px';
		height: 100%;
		width: 100%;
	}
	.my-canvas {
		border-radius: '10px';
		height: 100%;
		width: 100%;
	}
	img {
		border-radius: '10px';
		width: 100%;
		height: 100%;
	}
</style>
